import React from "react";
import "../style.css"
import Header from "../components/Header";
const Welcome: React.FC = () => {
    return (
        <div data-overlay-container={true}>
            <Header props={ {showInstallButton: false}}/>
            <div className="relative z-10">
                <section id="welcome" className="pt-[150px] pb-[120px]">
                    <div className="container">
                        <div className="-mx-4 flex flex-wrap">
                            <div className="w-full px-4 flex flex-col justify-center items-center">
                                <div className="wow fadeInUp mx-auto max-w-[800px] text-center" data-wow-delay=".2s"><h1
                                    className="mb-10 text-3xl max-w-[650px] font-bold leading-tight text-black dark:text-white sm:text-4xl sm:leading-tight md:text-5xl md:leading-tight">
                                    Installation complete! 🎉<br/>
                                    Merge PDFs from your browser’s sidebar now.</h1><p
                                    className="mb-12 text-base font-medium !leading-relaxed text-body-color dark:text-white dark:opacity-90 sm:text-lg md:text-xl">1.
                                    Pin PDF Merger so it’s always available.</p></div>
                                <img alt="How to pin" loading="lazy" width="675" height="400" decoding="async"
                                     data-nimg="1" className="shadow-2xl rounded-xl" 
                                     src="/pictures/scr1.png"/>
                                <div className="wow fadeInUp mx-auto max-w-[800px] text-center mt-12 mb-6"
                                     data-wow-delay=".2s"><p
                                    className="mb-8 text-base font-medium !leading-relaxed text-body-color dark:text-white dark:opacity-90 sm:text-lg md:text-xl">2.
                                    Click its icon to launch PDF Merger and combine your PDFs.</p></div>
                                <img alt="How to open" loading="lazy" width="675" height="400" decoding="async"
                                     data-nimg="1" className="shadow-2xl rounded-xl" 
                                     src="/pictures/scr2.png"/></div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
};

export default Welcome;